<template>
  <div class="messages">
    <ul>
      <li v-for="(message, index) in messages" :key="index" :class="{ 'active': index === messages.length - 1 }">
        {{ message }}
      </li>
      <li v-if="showLoading" class="loading-item active">
        <span class="loading">
          <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MessagesList',
  props: {
    messages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showLoading: true,
    };
  },
  computed: {
    shouldShowLoading() {
      return this.messages.length === 0;
    }
  },
  watch: {
    messages: {
      immediate: true,
      handler(messages) {
        if (messages.length > 0) {
          this.showLoading = false;
        } else {
          this.showLoading = true;
        }
      }
    },
    shouldShowLoading(newValue) {
      this.showLoading = newValue;
    }
  },
  mounted() {
    if (this.messages.length > 0) {
      this.showLoading = false;
    }
  }
};
</script>

<style scoped>
.messages {
  background-color: var(--container-color);
  width: 75%;
  max-width: 1200px;
  height: 280px;
  overflow-y: auto;
  text-align: center;
  padding: 15px;
  border-radius: 8px;
  margin: 250px auto 0;
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: margin-top 0.5s ease, transform 0.5s ease;
}

.messages.connected {
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .messages {
    width: calc(100% - 30px);
    margin: 250px 15px;
    height: 450px;
    padding: 10px;
    box-sizing: border-box;
  }

  .messages.connected {
    margin: 80px 15px;
  }
}

.messages ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.messages li {
  font-size: 28px;
  font-family: 'Montserrat', sans-serif;
  color: var(--text-color);
  transition: filter 0.3s ease, opacity 0.3s ease;
  word-wrap: break-word;
}

.messages li:not(.active) {
  font-size: 22px;
  opacity: 0.6;
}

.messages li.active {
  font-weight: bold;
  filter: none;
  opacity: 1;
  padding-top: 16px;
  padding-bottom: 12px;
}

.loading-item {
  padding: 12px;
}

.loading {
  font-size: 24px;
  font-family: 'Montserrat', sans-serif;
  color: var(--text-color);
  display: flex;
  justify-content: center;
  gap: 4px;
}

.loading .dot {
  animation: blink 1.4s infinite;
}

.loading .dot:nth-child(1) {
  animation-delay: 0s;
}

.loading .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loading .dot:nth-child(3) {
  animation-delay: 0.4s;
}



@keyframes blink {

  0%,
  100% {
    opacity: 0.2;
  }

  50% {
    opacity: 1;
  }
}
</style>